<template>
  <div>
    <small style="white-space: break-spaces;">{{ $t("info")}}</small>
    <br />
    <div class="table-responsive">
      <table class="table table-sm table-hover mytable w-auto">
        <thead>
          <tr>
            <td class="text-right"><small>{{ $t("case")}}</small></td>
            <td><span v-html="getSpaces"/></td>
            <td :class="textClass(caseNumber)" v-for="caseNumber in getCaseNumbers" :key="caseNumber">
              &nbsp;{{ caseNumber }}&nbsp;
            </td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="player in $store.getters.getPlayers"
            :key="player.id"
            @click="toggleHasSpoken(player.id)"
          >
            <td>
              <base-button
                style="white-space: normal; padding-top: 0px; padding-bottom: 0px;"
                size="sm"
                type="primary"
                :aria-pressed="getAriaPressed(player.id)"
                :class="getActiveClass(player.id)"
              >
                <strong>{{ player.nick_name }}</strong>

                <font-awesome-icon
                      v-if="player.paused"
                      icon="pause"
                    />
              </base-button>
            </td>
            <td/>
            <td :class="textClass(caseNumber)" v-for="caseNumber in getCaseNumbers" :key="caseNumber" :style="cellStyle(caseNumber, player.id)">
                <template v-if="hasSpoken(caseNumber, player.id)">
                  X
                </template>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { sendSpeakingTurn } from "../services/APIService";

// Info has been split into 3 strings because of a bug in Safari

export default {
  computed: {
    getCaseNumbers() {
      const cases = [];

      for (let i = 1; i <= this.$store.state.main.game.currentCaseNumber; i++) {
        cases.push(i);
      }
      return cases;
    },
    getSpaces() {
      return "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
    },
  },
  methods: {
    hasSpoken(caseNumber, playerId) {
      for (let i = 0; i < this.$store.state.main.speakingTurns.length; i++) {
        const item = this.$store.state.main.speakingTurns[i];
        if (
          item.case_number === caseNumber &&
          item.player === playerId &&
          item.has_spoken
        ) {
          return true;
        }
      }
      return false;
    },
    async toggleHasSpoken(playerId) {
      const hasSpoken = !this.hasSpoken(
        this.$store.state.main.game.currentCaseNumber,
        playerId
      );
      const firstSpeakingTurn =
        this.$store.state.main.speakingTurns.length === 0;
      // Used only for statistics in backend

      // Let's explicitly set this also, otherwise this will
      // be too slow to use with firewall hack.
      this.$store.commit({
          type: "setOneSpeakingTurn",
          playerId: playerId,
          caseNumber: this.$store.state.main.game.currentCaseNumber,
          hasSpoken: hasSpoken,
        });

      sendSpeakingTurn(
        this.$store.state.main.game.id,
        playerId,
        this.$store.state.main.game.currentCaseNumber,
        this.$store.state.main.game.gameCode,
        hasSpoken,
        firstSpeakingTurn
      );
    },
    cellStyle(caseNumber, playerId) {
      const hasSpoken = this.hasSpoken(caseNumber, playerId);

      if (hasSpoken) {
        return "color: blue;"
      } else {
        return "";
      }
    },
    textClass(caseNumber) {
      if (caseNumber < this.$store.state.main.game.currentCaseNumber) {
        return "text-center"
      } else {
        return "text-center table-primary"
      }
    },
    getActiveClass(playerId) {
      // make button appear pressed
      if (this.hasSpoken(this.$store.state.main.game.currentCaseNumber, playerId)) {
        return "active";
      } else {
        return "";
      }
    },
    getAriaPressed(playerId) {
      return this.hasSpoken(this.$store.state.main.game.currentCaseNumber, playerId);
    }
  },
  created() {
    this.$store.dispatch("updateSpeakingTurns");
  },
};
</script>

<i18n>
{
  "en": {
    "info": "You can click on a name when a player is speaking if you wish. This will help you spot quieter players so you can activate them if necessary. The tracking is not printed in the report.",
    "case": "Case:"
  },
  "fi": {
    "info": "Voit halutessasi klikata nimeä, kun pelaaja puhuu. Näin havaitset hiljaisemmat pelaajat, jotta voit tarvittaessa aktivoida heitä. Seuranta ei tulostu raporttiin.",
    "case": "Tilanne:"
  },
  "sv": {
    "info": "Du kan klicka på ett namn när en spelare talar om du vill. Detta hjälper dig att upptäcka tystare spelare så att du kan aktivera dem om det behövs. Spårningen skrivs inte ut i rapporten.",
    "case": "Fall:"
  },
 "de": {
    "info": "Sie können auf einen Namen klicken, wenn ein Spieler spricht, wenn Sie möchten. So können Sie leisere Spieler erkennen und sie gegebenenfalls aktivieren. Das Tracking wird im Bericht nicht gedruckt.",
    "case": "Fall:"
  },
  "ko": {
    "info": "대화 참여 여부를 플레이어 이름 옆에 체크하여 참여도를 파악할 수 있습니다. 차트는 퍼실리테이터에게만 보여지며 결과보고서에 포함되지 않습니다.",
    "case": "주제:"
  }
}
</i18n>

<style scoped>
tr td{
  padding: 0 !important;
  margin: 0 !important;
}
</style>
